import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { CardItem } from 'src/app/components/Elements/Card';

export const SpacedOutCardItem = styled(CardItem)`
  display: flex !important;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.capsuleGreen60} !important;
`;
